import { Link } from "react-router-dom";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const Nav = () => {
  const { t, i18n } = useTranslation();
  const initialLang = (i18n && i18n.language) ? i18n.language : 'en';
  const [language, setLanguage] = useState(initialLang);

  const toggleLanguage = (event) => {
    event.preventDefault();
    const current = (i18n && i18n.language) ? i18n.language : (language || 'en');
    const isEn = String(current).toLowerCase().startsWith('en');
    const newLang = isEn ? 'zh' : 'en';
    i18n.changeLanguage(newLang);
    setLanguage(newLang);
  };

  const isEnUI = String((i18n && i18n.language) ? i18n.language : (language || 'en')).toLowerCase().startsWith('en');

  return (
    <ul className="mainmenu">
      <li className="has-droupdown">
        <Link to="/">{t("1")}</Link>
      </li>

      <li className="has-droupdown">
        <Link to="/AboutUs">{t("2")}</Link>
        <ul className="submenu">
          <li>
            <Link to="/AboutUs">{t("503")}</Link>
          </li>
          <li>
            <Link to="/AboutTeam">{t("500")}</Link>
          </li>
          <li>
            <Link to="/AboutScale">{t("501")}</Link>
          </li>
          <li>
            <Link to="/AboutPartner">{t("502")}</Link>
          </li>
        </ul>
      </li>

      <li className="has-droupdown">
        <Link to="/technologies">{t("3")}</Link>
      </li>

      <li className="has-droupdown">
        <Link to="#">{t("4")}</Link>
        <ul className="submenu">
          <li>
            <Link to="/PersonalRealInvestment">{t("71")}</Link>
          </li>
          <li>
            <Link to="/InvestmentStructuralDesign">{t("89")}</Link>
          </li>
          <li>
            <Link to="/ProjectDevelopmentAndManagement">{t("149")}</Link>
          </li>
          <li>
            <Link to="/PersonalHomeBuildingAdvice">{t("112")}</Link>
          </li>
          <li>
            <Link to="/FirstHomeBuyers">{t("192")}</Link>
          </li>
          <li>
            <Link to="/ExtensiveLandOldHouseRevitalization">{t("522")}</Link>
          </li>
        </ul>
      </li>

      <li className="has-droupdown">
        <Link to="/FinancePromise">{t("5")}</Link>
      </li>

      <li className="has-droupdown">
        <Link to="/StaffRecruitment">{t("5.1")}</Link>
      </li>

      <li className="has-droupdown">
        <Link to="/Contact">{t("6")}</Link>
      </li>

      <li className="has-dropdown">
        <Link to="#" onClick={toggleLanguage}>
          {isEnUI ? "EN/中文" : "中文/EN"}
        </Link>
      </li>
    </ul>
  );
};
export default Nav;
